/**
 * AureusLogo — le VRAI logo de marque (écusson doré « A »), partout.
 * -------------------------------------------------------------------
 * Règle fondateur 28/07/2026 : « LE LOGO DOIT ÊTRE PARTOUT, MÊME SUR L'ICÔNE
 * DU SITE WEB ». Avant ça, chaque écran dessinait son propre ersatz : un
 * triangle SVG bricolé (vitrine, early-access), un « ▲ » sur la page de
 * connexion, les initiales « AS » dans la bannière PWA, ou juste le mot
 * AUREUS en doré. Un seul composant, une seule source : public/logo-mark.svg.
 *
 * Source unique  : public/logo-mark.svg (vectoriel — net à toutes les tailles)
 * Régénération   : scripts/vectorize-logo.mjs (depuis logo-full-transparent.png)
 * Icônes de site : scripts/generate-favicons.mjs
 *
 * Usage :
 *   <AureusLogo size={32} />                          écusson seul
 *   <AureusLogo size={34} withText />                  écusson + « AUREUS / SOCIAL PRO »
 *   <AureusLogo size={34} withText tone="dark" />      variante fond sombre
 *
 * L'écusson est en ratio portrait : `size` = HAUTEUR rendue, la largeur suit.
 * Pas de composant défini en ligne ici (R4) et aucun état — utilisable aussi
 * bien depuis un Server Component que depuis un composant client.
 */

const OR = '#c6a34e';

// Palette du bloc texte selon le fond sur lequel le logo est posé.
const TONS = {
  light: { titre: '#0E0D0A', sous: '#9A968E' },
  dark: { titre: '#FFFFFF', sous: 'rgba(255,255,255,.45)' },
  gold: { titre: OR, sous: 'rgba(255,255,255,.45)' },
};

export default function AureusLogo({
  size = 32,
  withText = false,
  tone = 'light',
  gap = 10,
  title = 'Aureus Social Pro',
  style = {},
  textStyle = {},
  onClick,
  priority = false,
}) {
  const t = TONS[tone] || TONS.light;
  const mark = (
    <img
      src="/logo-mark.svg"
      alt={title}
      width={Math.round(size * 0.638)} /* ratio de l'écusson : 342 × 536 */
      height={size}
      loading={priority ? 'eager' : 'lazy'}
      decoding="async"
      style={{ height: size, width: 'auto', display: 'block', flexShrink: 0 }}
    />
  );

  if (!withText) {
    return onClick || Object.keys(style).length
      ? <span onClick={onClick} style={{ display: 'inline-flex', ...style }}>{mark}</span>
      : mark;
  }

  return (
    <span
      onClick={onClick}
      style={{ display: 'inline-flex', alignItems: 'center', gap, cursor: onClick ? 'pointer' : undefined, ...style }}
    >
      {mark}
      <span style={{ display: 'block', lineHeight: 1.15, ...textStyle }}>
        <span style={{ display: 'block', fontSize: Math.max(11, Math.round(size * 0.42)), fontWeight: 800, color: t.titre, letterSpacing: '.06em' }}>AUREUS</span>
        <span style={{ display: 'block', fontSize: Math.max(7, Math.round(size * 0.25)), color: t.sous, letterSpacing: '.2em', textTransform: 'uppercase' }}>Social Pro</span>
      </span>
    </span>
  );
}
